var cqP = {
  "./de.js": require("./81.js"),
  "./en.js": require("./82.js"),
  "./es.js": require("./83.js"),
  "./kr.js": require("./84.js")
};
function cqQ(cqM) {
  return cqP[cqM];
}
function cqT(cqM) {
  return cqM;
}
cqQ.keys = function () {
  return Object.keys(cqP);
};
cqQ.resolve = cqT;
module.exports = cqQ;
cqQ.id = 80;